import { forwardRef, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DatePickerRange as Component, type DatePickerRangeProps, type DatePickerRangeTranslations } from '@/js/libs/ui/src/V2';

export const DatePickerRange = memo(
  forwardRef<HTMLInputElement, DatePickerRangeProps>(function DatePickerRange({ translations, ...props }, ref) {
    const [t] = useTranslation(['common']);

    const mergedTranslations = useMemo<DatePickerRangeTranslations>(
      () => ({
        period: t('common:PERIOD'),
        ...translations,
      }),
      [t, translations],
    );

    return <Component translations={mergedTranslations} ref={ref} {...props} />;
  }),
);
